define('mrg-smokescreen/StyleSheets.NativeParser', [
	'mrg-smokescreen/Utils'
], function(Utils) {
	function _getRules(sheet) {
		try {
			return sheet.cssRules || sheet.rules;

		} catch(e) {
			return null;
		}
	}

	function _replaceUrls(data, baseUrl) {
		var firstChunk = true;

		return data.split('url(').map(function (chunk) {
			if (firstChunk) {
				firstChunk = false;
				return chunk;
			}
	
			return Utils.replaceUrl(chunk, baseUrl, true);
		}).join('url(');
	}

	var RE_CONTENT = /content\s*:\s*/;

	function _replaceContent(data) {
		var firstChunk = true;

		return data.split(RE_CONTENT).map(function (chunk) {
			if (firstChunk) {
				firstChunk = false;
				return chunk;
			}
	
			return Utils.replaceContent(chunk);
		}).join('content:');
	}

	function _toCamelCase(str) {
		return str.replace(/-([a-z])/g, function (g) {
			return g[1].toUpperCase();
		});
	}

	var RE_NUM_VAL = /^(-?\d+)([a-z%]+)$/
	// регулярка для разбиения сложных значений, помогает избежать проблем с заменой внутри ф-ций
	var RE_CSS_VAL_SPLIT = /\s(?![*+\-/]|[^()]+\)+|\(+)/

	function _convertRule(rule, _convert, baseUrl, options) {
		/**
		 * https://developer.mozilla.org/ru/docs/Web/API/CSSStyleDeclaration
		 */

		var cssText = '';
		var selector = _convert(rule.selectorText);

		var propertyKeys = [
			// Хак для исправления css-переменных
			//
			// Если стречаются составные свойства аля border: var(--css-variable),
			// то т.к. переменная не определена, то они не парсится. По-этому мы явно
			// пытаемся вытащить значение по нужным ключам
			// список можно дополнять
			// TODO: может, есть способ лучше???
			'border',
			'border-top',
			'border-left',
			'border-right',
			'border-bottom',
			'background'
		];

		for (var i = 0; i < rule.style.length; i++) {
			propertyKeys.push(rule.style[i]);
		}

		propertyKeys.forEach(function (styleName) {
			var important = (rule.style.getPropertyPriority(styleName) === 'important') ? ' !important' : '';


			// куйня со стилями в Safari
			if(/background-(repeat|position)-[xy]/.test(styleName)) {
				styleName = styleName.replace(/-[xy]$/, '');
			}

			// пробуем сменить property-name на propertyName изза Firefox30
			var value = rule.style[styleName] || rule.style[_toCamelCase(styleName)];

			if(value === undefined || !value.length) {
				// в Firefox30 некоторые правила записываются с дурацкими постфиксами
				styleName = styleName.replace(/-(value|(ltr|rtl)-source)$/g, '');
				value = rule.style[styleName] || rule.style[_toCamelCase(styleName)];
			}

			// в Firefox30 float живет в другом поле
			if(value === undefined && styleName === 'float') {
				value = rule.style.cssFloat;
			}

			if(value !== undefined && value.length) {
				// если указано в опциях - автоматически преобразуем точные цифровые значения свойств в рандомные
				// но только для тех селекторов, которые попали под модификацию
				if(
					options.randomize && options.randomize.length && options.randomize.indexOf(styleName) > -1
					&& selector != rule.selectorText
				) {
					var parts = value.split(RE_CSS_VAL_SPLIT), pLen = parts.length, nVal = [];

					while(pLen--) {
						var num = RE_NUM_VAL.exec(parts[pLen]);

						nVal.unshift(num ? Utils.calcString(num[1], num[2]) : parts[pLen])
					}

					value = nVal.join(' ')
				}

				cssText += styleName + ': ' + value + important + '; ';
			}
		});

		if(cssText.indexOf('url(') !== -1) {
			cssText = _replaceUrls(cssText, baseUrl);
		}

		if(cssText.indexOf('content') !== -1) {
			cssText = _replaceContent(cssText, baseUrl);
		}

		return selector + ' { ' + cssText + ' }';
	}

	return {
		iterate: function(sheet, _convert, baseUrl, callback, options) {
			options = options || {}

			Utils.iterate(_getRules(sheet), function(rule) {
				switch(rule.type) {
					// CSSRule.STYLE_RULE обычное правило
					case 1:
						callback(_convertRule(rule, _convert, baseUrl, options));
						break;

					// CSSRule.MEDIA_RULE - @media
					case 4:
						var mediaRulesList = [];
						Utils.iterate(rule.cssRules || rule.rules, function(subRule) {
							mediaRulesList.push(_convertRule(subRule, _convert, baseUrl, options));
						});

						callback('@media ' + rule.media.mediaText + ' { ' + mediaRulesList.join(' ') + ' }' );
						break;

					default:
						callback(rule.cssText);
						break;
				}
			});
		}
	}
});